import { Route, Switch } from "react-router-dom";
import { DesignPackageProductCardPage } from "src/routes/libraries/design-catalog/design-package-configurator/DesignPackageProductCardPage";
import {
  designCatalogPath,
  designPackageAddProductPath,
  designPackageAddToSlotPath,
  designPackageNewSlotPath,
  designPackageProductCardPath,
  designPackageProductSearchPath,
} from "src/routes/routesDef";
import { DesignPackageConfigurator } from "./DesignPackageConfigurator";
import { DesignPackageConfiguratorProvider } from "./DesignPackageConfiguratorContext";
import { AddProductPage } from "./components/AddProductPage";
import { NewProductSlotPage } from "./routes/new/NewProductSlotPage";
import { ProductSearchPage } from "./routes/search/ProductSearchPage";

export function DesignPackageConfiguratorLayout() {
  return (
    <DesignPackageConfiguratorProvider>
      <Switch>
        <Route path={designPackageNewSlotPath} exact component={NewProductSlotPage} />
        <Route
          path={designPackageAddToSlotPath}
          exact
          render={() => <NewProductSlotPage addingNewFamilyToExistingSlot />}
        />
        <Route path={designPackageProductCardPath} exact component={DesignPackageProductCardPage} />
        <Route path={designPackageProductSearchPath} exact component={ProductSearchPage} />
        <Route path={designPackageAddProductPath} exact component={AddProductPage} />
        <Route path={designCatalogPath} exact component={DesignPackageConfigurator} />
      </Switch>
    </DesignPackageConfiguratorProvider>
  );
}
